import React, { createContext, useContext, useState } from "react";

import en from "../translations/en.json";
import de from "../translations/de.json";
import fr from "../translations/fr.json";

const translations = {
  en,
  de,
  fr,
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("fr"); // default FR

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
